export default __webpack_public_path__ + "static/media/AppletSelectedCheck.8f3626e6.webp";